import { cn } from "@babybjorn/ui";
import {
	Suspense,
	lazy,
	type FC,
	type LazyExoticComponent,
	type ReactNode,
	type SVGAttributes,
} from "react";
import { isValidFlag } from "../Flag/Flag";
import * as s from "./Icon.module.scss";

const Flag = lazy(() => import("../Flag"));

const CubeIcon = lazy(() => import("../../../assets/icons/cube.svg"));
const ArIcon = lazy(() => import("../../../assets/icons/ar.svg"));
const ArrowDownIcon = lazy(
	() => import("../../../assets/icons/arrow-down.svg"),
);
const ArrowLeftIcon = lazy(
	() => import("../../../assets/icons/arrow-left.svg"),
);
const ArrowRightIcon = lazy(
	() => import("../../../assets/icons/arrow-right.svg"),
);
const ArrowUpIcon = lazy(() => import("../../../assets/icons/arrow-up.svg"));
const BabyIcon = lazy(() => import("../../../assets/icons/baby.svg"));
const BoxIcon = lazy(() => import("../../../assets/icons/box.svg"));
const CalendarIcon = lazy(() => import("../../../assets/icons/calendar.svg"));
const CartAddIcon = lazy(() => import("../../../assets/icons/cart-add.svg"));
const CartTinyIcon = lazy(() => import("../../../assets/icons/cart-tiny.svg"));
const CartIcon = lazy(() => import("../../../assets/icons/cart.svg"));
const CheckmarkIcon = lazy(() => import("../../../assets/icons/checkmark.svg"));
const CloseTinyIcon = lazy(
	() => import("../../../assets/icons/close-tiny.svg"),
);
const CloseIcon = lazy(() => import("../../../assets/icons/close.svg"));
const DotSingleIcon = lazy(
	() => import("../../../assets/icons/dot-single.svg"),
);
const DotsThreeIcon = lazy(
	() => import("../../../assets/icons/dots-three.svg"),
);
const EditIcon = lazy(() => import("../../../assets/icons/edit.svg"));
const FacebookIcon = lazy(() => import("../../../assets/icons/facebook.svg"));
const FilterIcon = lazy(() => import("../../../assets/icons/filter.svg"));
const GiftCard = lazy(() => import("../../../assets/icons/gift-card.svg"));
const GiftEnvelope = lazy(
	() => import("../../../assets/icons/gift-envelope.svg"),
);
const InfoIcon = lazy(() => import("../../../assets/icons/info.svg"));
const InstagramIcon = lazy(() => import("../../../assets/icons/instagram.svg"));
const LinkIcon = lazy(() => import("../../../assets/icons/link.svg"));
const LocationIcon = lazy(() => import("../../../assets/icons/location.svg"));
const ManualsIcon = lazy(() => import("../../../assets/icons/manuals.svg"));
const MasterCardIcon = lazy(
	() => import("../../../assets/icons/master-card.svg"),
);
const MenuBurgerIcon = lazy(
	() => import("../../../assets/icons/menu-burger.svg"),
);
const MenuIcon = lazy(() => import("../../../assets/icons/menu.svg"));
const MessageIcon = lazy(() => import("../../../assets/icons/message.svg"));
const MetaIcon = lazy(() => import("../../../assets/icons/meta.svg"));
const MinusIcon = lazy(() => import("../../../assets/icons/minus.svg"));
const PhotoIcon = lazy(() => import("../../../assets/icons/photo.svg"));
const PlayIcon = lazy(() => import("../../../assets/icons/play.svg"));
const PlusIcon = lazy(() => import("../../../assets/icons/plus.svg"));
const QuestionTinyIcon = lazy(
	() => import("../../../assets/icons/question-tiny.svg"),
);
const QuestionIcon = lazy(() => import("../../../assets/icons/question.svg"));
const ReloadIcon = lazy(() => import("../../../assets/icons/reload.svg"));
const LoadingIcon = lazy(() => import("../../../assets/icons/loading.svg"));
const SearchIcon = lazy(() => import("../../../assets/icons/search.svg"));
const ShareAltIcon = lazy(() => import("../../../assets/icons/share-alt.svg"));
const ShareIcon = lazy(() => import("../../../assets/icons/share.svg"));
const ShieldCheckIcon = lazy(
	() => import("../../../assets/icons/shield-check.svg"),
);
const ShippingIcon = lazy(() => import("../../../assets/icons/shipping.svg"));
const StarFilledTinyIcon = lazy(
	() => import("../../../assets/icons/star-filled-tiny.svg"),
);
const StarFilledIcon = lazy(
	() => import("../../../assets/icons/star-filled.svg"),
);
const StarStrokeTinyIcon = lazy(
	() => import("../../../assets/icons/star-stroke-tiny.svg"),
);
const StarStrokeIcon = lazy(
	() => import("../../../assets/icons/star-stroke.svg"),
);
const TikTokIcon = lazy(() => import("../../../assets/icons/tiktok.svg"));
const VideoIcon = lazy(() => import("../../../assets/icons/video.svg"));
const WashIcon = lazy(() => import("../../../assets/icons/wash.svg"));
const YoutubeIcon = lazy(() => import("../../../assets/icons/youtube.svg"));
const ZoomInIcon = lazy(() => import("../../../assets/icons/zoom-in.svg"));
const FastDeliveryIcon = lazy(
	() => import("../../../assets/icons/fast-delivery.svg"),
);
const Return14Icon = lazy(() => import("../../../assets/icons/return-14.svg"));
const Return30Icon = lazy(() => import("../../../assets/icons/return-30.svg"));
const Return60Icon = lazy(() => import("../../../assets/icons/return-60.svg"));
const Return90Icon = lazy(() => import("../../../assets/icons/return-90.svg"));
const HeartHandIcon = lazy(
	() => import("../../../assets/icons/heart-hand.svg"),
);
const SafePayIcon = lazy(() => import("../../../assets/icons/safe-pay.svg"));
const BlogIcon = lazy(() => import("../../../assets/icons/blog.svg"));
const GiftIcon = lazy(() => import("../../../assets/icons/gift.svg"));
const LineIcon = lazy(() => import("../../../assets/icons/line.svg"));
const MessengerIcon = lazy(() => import("../../../assets/icons/messenger.svg"));
const PinIcon = lazy(() => import("../../../assets/icons/pin.svg"));
const PinterestIcon = lazy(() => import("../../../assets/icons/pinterest.svg"));
const TwitterIcon = lazy(() => import("../../../assets/icons/twitter.svg"));

//PAYMENT METHODS
const AfterpayIcon = lazy(() => import("../../../assets/icons/afterpay.svg"));
const AliPayHkIcon = lazy(() => import("../../../assets/icons/alipay-hk.svg"));
const AmazonPayIcon = lazy(
	() => import("../../../assets/icons/amazon-pay.svg"),
);
const AmericanExpressIcon = lazy(
	() => import("../../../assets/icons/american-express.svg"),
);
const ApplePayIcon = lazy(() => import("../../../assets/icons/apple-pay.svg"));
const AtomeIcon = lazy(() => import("../../../assets/icons/atome.svg"));
const BizumIcon = lazy(() => import("../../../assets/icons/bizum.svg"));
const CartesBancairesIcon = lazy(
	() => import("../../../assets/icons/cartes-bancaires.svg"),
);
const DinersIcon = lazy(() => import("../../../assets/icons/diners.svg"));
const DiscoverIcon = lazy(() => import("../../../assets/icons/discover.svg"));
const GiroPayIcon = lazy(() => import("../../../assets/icons/giro-pay.svg"));
const GoogleMapsIcon = lazy(
	() => import("../../../assets/icons/google-maps.svg"),
);
const GooglePayIcon = lazy(
	() => import("../../../assets/icons/google-pay.svg"),
);
const GooglePayMarkIcon = lazy(
	() => import("../../../assets/icons/google-pay-mark.svg"),
);
const IDealIcon = lazy(() => import("../../../assets/icons/i-deal.svg"));
const JcbPayIcon = lazy(() => import("../../../assets/icons/jcb-pay.svg"));
const KakaoPayIcon = lazy(() => import("../../../assets/icons/kakao-pay.svg"));
const KlarnaIcon = lazy(() => import("../../../assets/icons/klarna.svg"));
const NaverPayIcon = lazy(() => import("../../../assets/icons/naver-pay.svg"));
const PaidyIcon = lazy(() => import("../../../assets/icons/paidy.svg"));
const PaycoIcon = lazy(() => import("../../../assets/icons/payco.svg"));
const PaypalIcon = lazy(() => import("../../../assets/icons/paypal.svg"));
const PayPayIcon = lazy(() => import("../../../assets/icons/pay-pay.svg"));
const RPayIcon = lazy(() => import("../../../assets/icons/r-pay.svg"));
const SwishIcon = lazy(() => import("../../../assets/icons/swish.svg"));
const UnionPayIcon = lazy(() => import("../../../assets/icons/union-pay.svg"));
const VisaIcon = lazy(() => import("../../../assets/icons/visa.svg"));
const WeChatPayIcon = lazy(
	() => import("../../../assets/icons/we-chat-pay.svg"),
);
const WhatsappIcon = lazy(() => import("../../../assets/icons/whatsapp.svg"));

const iconTypes = [
	"cube",
	"ar",
	"arrow-down",
	"arrow-left",
	"arrow-right",
	"arrow-up",
	"baby",
	"box",
	"calendar",
	"cart-add",
	"cart",
	"checkmark",
	"close",
	"dot-single",
	"dots-three",
	"edit",
	"filter",
	"gift-card",
	"gift-envelope",
	"link",
	"location",
	"manuals",
	"menu-burger",
	"menu",
	"message",
	"minus",
	"photo",
	"play",
	"plus",
	"info",
	"question",
	"reload",
	"loading",
	"search",
	"share-alt",
	"share",
	"shield-check",
	"shipping",
	"star-filled",
	"star-stroke",
	"video",
	"wash",
	"zoom-in",
	"meta",
	"instagram",
	"youtube",
	"pinterest",
	"tiktok",
	"facebook",
	"mastercard",
	"visa",
	"klarna",
	"cart-tiny",
	"close-tiny",
	"question-tiny",
	"star-filled-tiny",
	"star-stroke-tiny",
	"fast-delivery",
	"return-14",
	"return-30",
	"return-60",
	"return-90",
	"heart-hand",
	"safe-pay",
	"afterpay",
	"american-express",
	"apple-pay",
	"blog",
	"gift",
	"google-maps",
	"google-pay",
	"google-pay-mark",
	"messenger",
	"paypal",
	"pin",
	"pinterest",
	"r-pay",
	"line",
	"twitter",
	"whatsapp",
	"swish",
	"alipay-hk",
	"amazon-pay",
	"atome",
	"diners",
	"giro-pay",
	"i-deal",
	"jcb-pay",
	"kakao-pay",
	"naver-pay",
	"paidy",
	"pay-pay",
	"payco",
	"union-pay",
	"we-chat-pay",
	"bizum",
	"cartes-bancaires",
	"discover",
] as const;

type IconTypes = typeof iconTypes;
export type IconType = IconTypes[number];

const icons: Record<
	IconType,
	LazyExoticComponent<FC<SVGAttributes<SVGElement>>>
> = {
	cube: CubeIcon,
	ar: ArIcon,
	"arrow-down": ArrowDownIcon,
	"arrow-left": ArrowLeftIcon,
	"arrow-right": ArrowRightIcon,
	"arrow-up": ArrowUpIcon,
	baby: BabyIcon,
	box: BoxIcon,
	calendar: CalendarIcon,
	"cart-add": CartAddIcon,
	cart: CartIcon,
	checkmark: CheckmarkIcon,
	close: CloseIcon,
	"dot-single": DotSingleIcon,
	"dots-three": DotsThreeIcon,
	edit: EditIcon,
	filter: FilterIcon,
	"gift-card": GiftCard,
	"gift-envelope": GiftEnvelope,
	link: LinkIcon,
	location: LocationIcon,
	manuals: ManualsIcon,
	"menu-burger": MenuBurgerIcon,
	menu: MenuIcon,
	message: MessageIcon,
	minus: MinusIcon,
	photo: PhotoIcon,
	play: PlayIcon,
	plus: PlusIcon,
	question: QuestionIcon,
	reload: ReloadIcon,
	loading: LoadingIcon,
	search: SearchIcon,
	"share-alt": ShareAltIcon,
	share: ShareIcon,
	"shield-check": ShieldCheckIcon,
	shipping: ShippingIcon,
	"star-filled": StarFilledIcon,
	"star-stroke": StarStrokeIcon,
	video: VideoIcon,
	wash: WashIcon,
	"zoom-in": ZoomInIcon,
	meta: MetaIcon,
	info: InfoIcon,
	instagram: InstagramIcon,
	youtube: YoutubeIcon,
	pinterest: PinterestIcon,
	tiktok: TikTokIcon,
	facebook: FacebookIcon,
	"cart-tiny": CartTinyIcon,
	"close-tiny": CloseTinyIcon,
	"question-tiny": QuestionTinyIcon,
	"star-filled-tiny": StarFilledTinyIcon,
	"star-stroke-tiny": StarStrokeTinyIcon,
	"fast-delivery": FastDeliveryIcon,
	"return-14": Return14Icon,
	"return-30": Return30Icon,
	"return-60": Return60Icon,
	"return-90": Return90Icon,
	"heart-hand": HeartHandIcon,
	"safe-pay": SafePayIcon,
	blog: BlogIcon,
	gift: GiftIcon,
	line: LineIcon,
	messenger: MessengerIcon,
	pin: PinIcon,
	whatsapp: WhatsappIcon,
	twitter: TwitterIcon,
	swish: SwishIcon,
	mastercard: MasterCardIcon,
	visa: VisaIcon,
	klarna: KlarnaIcon,
	afterpay: AfterpayIcon,
	"american-express": AmericanExpressIcon,
	"apple-pay": ApplePayIcon,
	"google-maps": GoogleMapsIcon,
	"google-pay": GooglePayIcon,
	"google-pay-mark": GooglePayMarkIcon,
	paypal: PaypalIcon,
	"r-pay": RPayIcon,
	"alipay-hk": AliPayHkIcon,
	"amazon-pay": AmazonPayIcon,
	atome: AtomeIcon,
	diners: DinersIcon,
	"giro-pay": GiroPayIcon,
	"i-deal": IDealIcon,
	"jcb-pay": JcbPayIcon,
	"kakao-pay": KakaoPayIcon,
	"naver-pay": NaverPayIcon,
	paidy: PaidyIcon,
	"pay-pay": PayPayIcon,
	payco: PaycoIcon,
	"union-pay": UnionPayIcon,
	"we-chat-pay": WeChatPayIcon,
	bizum: BizumIcon,
	"cartes-bancaires": CartesBancairesIcon,
	discover: DiscoverIcon,
};

type IconVariant = "primary" | "inverted" | "secondary" | "rating" | "social";

type IconProps = {
	icon?: string;
	variant?: IconVariant;
	width?: number | "none";
	height?: number | "none";
	color?: string;
	className?: string;
	loading?: boolean;
	hasSpinningDots?: boolean;
};

export const isValidIcon = (icon?: unknown): icon is IconType =>
	typeof icon === "string" && iconTypes.includes(icon as IconTypes[number]);

const Icon: FC<IconProps> = ({
	icon,
	width = 24,
	height = "none",
	variant,
	color,
	loading,
	hasSpinningDots,
	className,
}) => {
	const variantClass = variant ? s[variant] : "";

	const fallBackDiv = (
		<div
			style={{
				minWidth: width === "none" ? "none" : width / 16 + "rem",
			}}
		></div>
	);

	let displayIcon: ReactNode = fallBackDiv;

	if (loading) {
		displayIcon = hasSpinningDots ? (
			<LoadingIcon
				height={width}
				className={cn(className, s.spin, variantClass)}
			/>
		) : (
			<ReloadIcon
				height={width}
				className={cn(className, s.spin, variantClass)}
			/>
		);
	} else if (icon && !isValidIcon(icon) && isValidFlag(icon)) {
		displayIcon = (
			<Flag
				flagOverride={icon}
				width={width}
				ariaLabel={`Flag for country with country code ${icon}`}
			/>
		);
	} else if (isValidIcon(icon)) {
		const IconComponent = icons[icon];
		displayIcon = (
			<IconComponent
				preserveAspectRatio="xMidYMid"
				style={{
					color: color,
					width: width === "none" ? "none" : width / 16 + "rem",
					height: height === "none" ? "none" : height / 16 + "rem",
				}}
				className={cn(s.icon, className, variantClass)}
			/>
		);
	}

	return <Suspense fallback={fallBackDiv}>{displayIcon}</Suspense>;
};

export default Icon;
